export default "__VITE_ASSET__BRm$Ctn___"